<template>
    <div class="course_content use_common" :class="{ course_content_bottom: !isBeginActivity, course_content_bottom_iphoneX: isIphoneX}">
        <!--活动未结束-->
        <div v-if="!isEndActivity" v-cloak>
            <div v-if="activityInfo.bannerUrl">
                <img class="course_bg" :src="activityInfo.bannerUrl" alt="">
                <div class="title_radius"></div>
            </div>
            <div class="banner_height" v-else></div>
            <!--标题栏内容-->
            <div class="title_content" v-if="navNumberList.length > 0">
                <div class="school_title_content flex_box" @click="selectSchoolType(1)" v-if="navNumberList.indexOf(0) > -1">
                    <img class="school_icon" src="../../assets/schoolicon.png" alt="">
                    <div class="school_title tow">
                        校区：{{schoolName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
                <div class="school_title_content flex_box" @click="selectSchoolType(2)" v-if="navNumberList.indexOf(1) > -1">
                    <img class="school_icon" src="../../assets/schoolclassicon.png" alt="">
                    <div class="school_title tow">
                        年级：{{gradeName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
                <div class="school_title_content flex_box" @click="selectSchoolType(3)" v-if="navNumberList.indexOf(3) > -1 && selectNavString == navNumberShowString">
                    <img class="school_icon" src="../../assets/schooltimeicon.png" alt="">
                    <div class="school_title tow">
                        时间：{{timeName || '请选择'}}
                    </div>
                    <img class="down_arrow_icon" src="../../assets/downarrow.png" alt="">
                </div>
            </div>
            <!--课程内容-->
            <v-reload
                    :on-infinite-load="onInfiniteLoad"
                    :parent-pull-up-state="pullUpState"
                    :footer-content="isShowPullUpFooter"
            >
                <div class="course_package_list">
                    <div class="package_content" v-for="(packageItem, packageIndex) in packageList" :key="packageItem.packageCode" :class="{package_content_bottom: packageList.length !== packageIndex+1}">
                        <div class="package_title flex_box">
                            <div class="package_title_text tow">{{packageItem.packageName}}</div>
                            <div class="add_package" @click="selectAll(packageItem)" :class="{add_package_color: packageItem.isSoldOut}">{{packageItem.isSoldOut ? '已报满' : packageItem.isSelectAll ? '取消套报' : '套报'}}</div>
                        </div>
                        <div class="course_list_details" v-for="(courseItem, courseIndex) in packageItem.classList" :key="courseIndex" :class="{course_list_details_opacity: courseItem.registrationState===6}" @click="selectCourse(packageItem, courseItem)">
                            <div class="course_name_content">
                                <span class="class_type" v-if="courseItem.seasonName">{{courseItem.seasonName}}</span>
                                <span class="teaching_methods" v-if="courseItem.teachingMethod&&teachingMethod(courseItem.teachingMethod)">{{teachingMethod(courseItem.teachingMethod || '')}}</span>
                                <span class="course_name">{{courseItem.className}}</span>
                            </div>
                            <div class="flex_box class_num_time">
                                <span class="lessons_num">{{courseItem.classCode}}</span>
                                <span class="lessons_num">{{getClassLessonTimes(courseItem.lessonTimes, (courseItem.realMinutes || 0))}}</span>
                                <span class="lessons_num" v-if="getClassStay(courseItem.classMode || '')">住宿班</span>
                                <span class="course_quota" v-if="courseItem.registrationState===1&&isFew((courseItem.maxNum - courseItem.usableCount), courseItem.maxNum, courseItem.registrationState)">名额紧张</span>
                                <span class="course_quota" v-if="courseItem.registrationState===2||courseItem.registrationState===3">已开课/可插班</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===4">已开课</span>
                                <span class="course_quota open_course_status" v-if="courseItem.registrationState===6">已报满</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="learn_place_icon" src="../../assets/cardaddricon.png" />
                                <span class="class_num tow">{{courseItem.learnPlace}}</span>
                            </div>
                            <div class="flex_box course_details">
                                <img class="card_year_icon" src="../../assets/cardyearicon.png" />
                                <span class="class_num">{{formatDate(new Date(courseItem.startDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')+'至'+formatDate(new Date(courseItem.endDate.replace(/-/g, '/') + '+0800'), 'yyyy/MM/dd')}}</span>
                            </div>
                            <div class="course_details course_time_details">
                                <img class="card_time_icon" src="../../assets/cardtimeicon.png" />
                                <div class="flex_box">
                                    <span class="time_details text_ellipsis_two">{{courseItem.learnTime}}</span>
                                </div>
                            </div>

                            <div class="first_shift_time" v-if="courseItem.registrationState===2||courseItem.registrationState===3">插班首次课时间：{{courseItem.insertLessonTimeText}}</div>
                            <div class="course_dot_line" v-else></div>

                            <div class="flex_box lesson_and_price_content">
                                <div  class="flex_box" v-if="courseItem.teacherList && courseItem.teacherList.length >= 1">
                                    <div class="more_teacher_content flex_box"  v-for="(teacherinfo, index) in courseItem.teacherList.slice(0, 2)" :key="index">
                                        <img class="teacher_icon" v-if="teacherinfo.newLogoUrl" :src="teacherinfo.newLogoUrl" onerror="javascript:this.src='https://cdn.xdf.cn/souke/h5-pages/components/teacher-info-card/images/default_teacher_photo.svg'"/>
                                        <img class="teacher_icon"  src="../../assets/cardteachericon.png" v-else/>
                                        <span class="teacher_name">{{teacherinfo.teacherName}}</span>
                                    </div>
                                    <div class="teacher_name" v-if="courseItem.teacherList && courseItem.teacherList.length > 2">...</div>
                                </div>
                                <div class="flex_box more_teacher_content" v-else>
                                    <img class="teacher_icon" src="../../assets/cardteachericon.png" />
                                    <span class="teacher_name">待定</span>
                                </div>

                                <div class="price_symbol_content">
                                    <span class="price_symbol">¥</span>
                                    <span class="course_price">{{courseItem.price}}</span>
                                </div>
                            </div>
                            <div class="select_icon">
                                <img v-if="courseItem.isSelect&&courseItem.registrationState!==6" src="../../assets/selectcourse.png" alt="">
                                <img v-else-if="courseItem.registrationState===6" src="../../assets/nocourse.png" alt="">
                                <img v-else src="../../assets/unselectcourse.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </v-reload>

            <div class="check_all_course flex_box" @click="checkAllCourse" v-if="activityInfo.detailUrl && tempPackageClassList.length > 3">
                <span class="all_course_title">查看全部套餐</span>
                <img class="course_left_arrow" src="../../assets/courseleftarrow.png" alt="">
            </div>
            <!--课程图片内容-->
            <div class="course_img" v-if="activityInfo.detailUrl || this.tempPackageClassList.length === 1 && this.tempPackageClassList[0].classList.length <= 2">
                <img :src="activityInfo.detailUrl" alt="">
            </div>
            <!--底部按钮-->
            <div class="activity_time" v-if="!isBeginActivity"  :class="{activity_time_bottom: isIphoneX}">
                活动将于{{beginTimeText}}开始
            </div>
            <div class="footer_content flex_box" :class="{footer_content_bottom: isIphoneX}">
                <a class="call_phone flex_box_column" :href="!isIosApp ? 'tel:' + phone : 'javascript:;'" @click="callPhone">
                    <img class="call_phone_icon" src="../../assets/callphoneicon.png" alt="">
                    <span class="call_phone_text">咨询</span>
                </a>
                <div class="buy_course" @click="payMoney">{{ cartList.length ? '立即抢购(' + cartList.length + ')' : '请选择课程'}}</div>
            </div>
        </div>
        <!--活动已结束-->
        <div v-if="isEndActivity">
            <end-activity></end-activity>
        </div>
        <!--弹窗内容-->
        <div class="school_list_bg" v-if="isShowPopupList">
            <div class="school_content">
                <div class="school_title_content flex_box">
                    <span class="school_title">{{popupTitle}}</span>
                    <img class="close_icon" src="../../assets/closeicon.png" alt="" @click="closePopupList">
                </div>

                <div class="school_list">
                    <div class="school_list_info" v-for="(item, index) in filterTypeList" :key="index" @click="selectFilterItem(item, index)">
                        <div class="school_name tow" :class="{school_name_color: (selectTypeId !== '' && Number(selectTypeId) === index)}">{{item}}</div>
                        <div class="dot_line"></div>
                    </div>
                    <!--                    <div class="school_list_info" v-for="(item, index) in [1,2,3,4,5,6,7,8,9,1,2,3,4,5,6,7,8,9]" :key="index" @click="selectFilterItem(item, index)">-->
                    <!--                        <div class="school_name tow">{{item + '哈哈哈'}}</div>-->
                    <!--                        <div class="dot_line"></div>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import wxSdk from '../../libs/wxsdk.js'
    import PullUpReload from '../../components/pullUpReload'
    import EndActivity from '../../components/endActivity'
    import {getNewMarketInfo, getNewMarketClassList, recordChannel, checkWxLogin, getGan} from '../../libs/api'
    import {formatDateUtil, teachingMethodUtil, getClassLessonTimesUtil, getClassStayUtil, isFewUtil, getIphoneXType, isWeChat} from "../../libs/util"
    import configData from '../../libs/conf'
    import { Indicator, Toast } from 'mint-ui'
    import Cookies from 'js-cookie'
    export default {
        name: "package",
        components: {
            'v-reload': PullUpReload,
            'end-activity': EndActivity
        },
        metaInfo () {
            return {
                title: this.pageName
            }
        },
        data() {
            return {
                phone: '',
                pageName: '新东方专题活动',
                isShowPage: false, // 是否显示页面
                isFixedHeight: false, // 是否固定页面高度
                isShowPopupList:false, // 是否显示弹窗列表
                popupTitle:'', // 弹窗标题
                navList: [], // 导航栏
                filterTypeList: [], // 筛选列表
                selectTypeId: '', // 选中筛选类型的Id
                filterNum: '', // 1: 学校 2: 年级  3: 时间
                schoolName: '', // 校区名字
                gradeName: '', // 年级名字
                timeName: '', // 时间名字
                selectSchoolId: '', // 选中的学校Id
                selectGradeId: '', // 选中的校区Id
                selectTimeId: '', // 选中的时间Id
                navNumberList:[], // 导航栏的存在的数字
                navNumberShowString: '', // 导航栏的存在先显示的数字
                selectNavString: '', // 选择学校0，时间1，科目2，显示时间栏
                activityInfo: '', // 活动信息
                beginTimeText: '', // 活动开始时间文本
                isBeginActivity: true, // 是否开始活动
                isEndActivity: false, // 是否结束活动
                packageList: [], // 套餐列表
                activityId: '', // 活动Id
                channelId: '', // 渠道Id
                pageNumber: 1, // 当前页数
                pageSize: 3, // 一页多少个
                total: '',  // 总量
                pullUpState: 1, // 子组件的pullUpState状态
                cartList: [], // 购物车
                isShowPullUpFooter: true, // 是否显示加载更多底部
                U2AT:'', // token
                schoolId: '', // 学校Id
                // 以下是信息缓存部分
                campusSet: [], // 校区纬度
                gradeSet: [], // 年级纬度
                subjectSet: [], // 科目纬度
                classTimeSet: [], // 时间纬度
                dimensionList: [], // 所有纬度list
                packageClassList: [], // 课程列表
                tempPackageClassList: [], // 临时存储的课程列表
                classCodeList: [], // 过滤的课程
                packageCodeList: [], // 过滤套餐列表
                isIosApp: false, // 是否是iosApp
                isIphoneX: false, // 是否iphoneX
                isWeChat: false, //  是否在微信环境内
                wxNickName: '', // 打点微信数据
                agentName: '', // 邮箱或者手机号
                agn: '' // 推广渠道
            }
        },
        created () {
            if (top.location != self.location) {
                sessionStorage.clear()
            }
        },
        mounted () {
            Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
            })
            let queryParams = this.$route.query
            // 获取标题参数
            let packageTitle = JSON.parse(sessionStorage.getItem('packageTitle'))
            if (!packageTitle) {
                packageTitle = queryParams
            }
            // console.log('获取参数', packageTitle)
            if (packageTitle) {
                this.schoolName = packageTitle.schoolName || ''
                this.selectSchoolId = packageTitle.selectSchoolId || ''
                this.gradeName = packageTitle.gradeName || ''
                this.selectGradeId  = packageTitle.selectGradeId || ''
                this.timeName  = packageTitle.timeName || ''
                this.selectTimeId  = packageTitle.selectTimeId || ''
                this.filterNum = Number(packageTitle.filterNum) || ''
                this.activityId = packageTitle.activityId || ''
                this.channelId = packageTitle.channelId || ''
                this.agn = packageTitle.agn || ''
                this.selectNavString = packageTitle.selectNavString || ''
                if (packageTitle.selectSchoolId === 0) {
                    this.selectSchoolId = 0
                }
                if (packageTitle.selectGradeId === 0) {
                    this.selectGradeId = 0
                }
                if (packageTitle.selectTimeId === 0) {
                    this.selectTimeId = 0
                }
                this.saveTitleInfo()
                switch(Number(this.filterNum)) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        break
                    case 3: // 时间名字
                        this.selectTypeId = this.selectTimeId
                        break
                }
            }

            // 判断是否在微信环境内,是否授权
            this.isWeChat = isWeChat()
            this.checkWxLogin()

            // 获取购物车数量
            this.cartList = JSON.parse(sessionStorage.getItem('cartList')) || []

            // 获取纬度及课程列表
            this.getMarketInfo()
            this.getMarketClassList()
            this.getGan()

            // 打点数据
            gio('page.set',{
                'activity_id': this.activityId,
                'channel_id': this.channelId
            })

            if (xdfJs.xdfhybird.inApp && !xdfJs.xdfhybird.android) {
                this.isIosApp = true
            }

            // 判断是否IphoneX
            this.isIphoneX = getIphoneXType()
        },
        methods: {
            // 选择筛选选项
            selectSchoolType(num) {
                document.documentElement.style.overflow = "hidden"
                this.filterNum = num
                this.selectTypeId = ''
                this.isFixedHeight = true
                this.isShowPopupList = true
                switch(num) {
                    case 1: // 校区名字
                        this.selectTypeId = this.selectSchoolId
                        this.popupTitle = '校区'
                        this.getDimensionList(1, 1)
                        break
                    case 2: // 年级名字
                        this.selectTypeId = this.selectGradeId
                        this.popupTitle = '年级'
                        this.getDimensionList(2, 1)
                        break
                    case 3: // 时间名字
                        this.popupTitle = '时间'
                        this.selectTypeId = this.selectTimeId
                        this.getDimensionList(3, 1)
                        break
                }
            },
            // 选择筛选列表
            selectFilterItem(itemName, itemIndex) {
                document.documentElement.style.overflow = "scroll"
                this.isFixedHeight = false
                this.isShowPopupList = false
                this.selectTypeId = itemIndex
                switch(this.filterNum) {
                    case 1: // 校区名字
                        this.selectSchoolId = itemIndex
                        this.schoolName = itemName
                        this.selectNavString = ''
                        if (this.selectNavString.indexOf('0') == -1) {
                            this.selectNavString += '0'
                        }
                        // 重新选择清空数据
                        this.selectGradeId = ''
                        this.gradeName = ''
                        this.selectTimeId = ''
                        this.timeName = ''
                        // 缓存信息
                        this.gradeSet = []
                        this.classTimeSet = []
                        break
                    case 2: // 年级名字
                        this.selectGradeId = itemIndex
                        this.gradeName = itemName
                        if (this.selectNavString.indexOf('1') == -1) {
                            this.selectNavString += '1'
                        }
                        // 重新选择清空数据
                        this.selectTimeId = ''
                        this.timeName = ''
                        // 缓存信息
                        this.classTimeSet = []
                        break
                    case 3: // 时间名字
                        this.selectTimeId = itemIndex
                        this.timeName = itemName
                        break
                }
                this.saveTitleInfo()
                this.packageList = []
                this.getDimensionList()
                this.getWxSdk()
            },
            // 存储标题参数
            saveTitleInfo () {
                // 存储学校名字
                let packageTitleInfo = {
                    schoolName: this.schoolName,
                    selectSchoolId: this.selectSchoolId,
                    gradeName: this.gradeName,
                    selectGradeId: this.selectGradeId,
                    timeName: this.timeName,
                    selectTimeId: this.selectTimeId,
                    filterNum: this.filterNum,
                    activityId: this.activityId,
                    channelId: this.channelId,
                    selectNavString: this.selectNavString,
                    agn: this.agn
                }
                sessionStorage.setItem('packageTitle', JSON.stringify(packageTitleInfo))
            },
            // 关闭弹窗
            closePopupList() {
                document.documentElement.style.overflow = "scroll"
                this.isFixedHeight = false
                this.isShowPopupList = false
            },
            // 获取专题详情
            getMarketInfo() {
                // 专题详情
                getNewMarketInfo(this.activityId).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        let data = resData.data
                        this.activityInfo = data.activityinfo
                        let nowTime = new Date(this.activityInfo.nowTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTime = new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800').valueOf()
                        let beginTimeText = formatDateUtil(new Date(this.activityInfo.beginTime.replace(/-/g, '/') + '+0800'), 'MM月dd日 HH:mm')
                        let endTime = new Date(this.activityInfo.endTime.replace(/-/g, '/') + '+0800').valueOf()
                        this.beginTimeText = beginTimeText
                        this.phone = this.activityInfo.connectPhone
                        this.schoolId = this.activityInfo.schoolId
                        this.pageName = this.activityInfo.title
                        // 活动未开始
                        if (nowTime < beginTime) {
                            this.isBeginActivity = false
                        }
                        // 活动已结束
                        if (nowTime > endTime) {
                            this.isEndActivity = true
                        }
                        // 是否有详情图片
                        if (this.activityInfo.detailUrl) {
                            this.isShowPullUpFooter = false
                        }

                        // 标题列表
                        this.navList = data.navList
                        this.navList.forEach((navItem) => {
                            this.navNumberList.push(navItem.type)
                            if (navItem.type < 2) {
                                this.navNumberShowString += navItem.type
                            }
                        })
                        // 微信分享
                        this.getWxSdk()
                        // 缓存信息内容
                        this.campusSet = data.campusSet
                        if (!this.schoolName && !this.gradeName && !this.subjectName && !this.timeName) {
                            this.gradeSet = data.gradeSet
                            this.subjectSet = data.subjectSet
                            this.classTimeSet = data.classTimeSet
                        }
                    }
                })
            },
            // 根据选择的纬度参数显示每一纬度的内容（所有情况下的纬度）
            getDimensionList(num, numType) {
                let filterNum
                if (num) {
                    filterNum = num
                } else {
                    filterNum = this.filterNum
                }
                if (!numType) {
                    this.classCodeList = []
                    this.packageCodeList = []
                }
                // 学校
                if (filterNum == 1) {
                    this.dimensionList.forEach((dimensionItem) => {
                        // 已选择的班号
                        if (dimensionItem.campusName === this.schoolName) {
                            if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                this.gradeSet.push(dimensionItem.gradeName)
                            }
                            if (this.classCodeList.indexOf(dimensionItem.classCode) === -1){
                                this.classCodeList.push(dimensionItem.classCode)
                            }

                            // 套餐号
                            if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                this.packageCodeList.push(dimensionItem.packageCode)
                            }
                        }
                    })
                }

                // 年级 要判断是否存在该纬度，并且是否存在上一级纬度
                if (filterNum == 2) {
                    if (this.schoolName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName) {
                                if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                    this.gradeSet.push(dimensionItem.gradeName)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    } else {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (this.gradeSet.indexOf(dimensionItem.gradeName) === -1) {
                                this.gradeSet.push(dimensionItem.gradeName)
                            }

                            // 已选择的班号
                            if (dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }

                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    }
                }

                // 学校，年级 / 学校 / 年级  /都没有
                if (filterNum == 3) {
                    if (this.schoolName && this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.gradeName === this.gradeName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    } else if (this.schoolName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.campusName === this.schoolName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.campusName === this.schoolName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    } else if (this.gradeName) {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (dimensionItem.gradeName === this.gradeName) {
                                if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                    this.classTimeSet.push(dimensionItem.classTime)
                                }
                            }

                            // 已选择的班号
                            if (dimensionItem.gradeName === this.gradeName && dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    } else {
                        this.dimensionList.forEach((dimensionItem) => {
                            // 仅仅获取有参数的初始纬度
                            if (this.classTimeSet.indexOf(dimensionItem.classTime) === -1) {
                                this.classTimeSet.push(dimensionItem.classTime)
                            }

                            // 已选择的班号
                            if (dimensionItem.classTime === this.timeName) {
                                if (this.classCodeList.indexOf(dimensionItem.classCode) === -1) {
                                    this.classCodeList.push(dimensionItem.classCode)
                                }

                                // 套餐号
                                if (this.packageCodeList.indexOf(dimensionItem.packageCode) === -1) {
                                    this.packageCodeList.push(dimensionItem.packageCode)
                                }
                            }
                        })
                    }
                }
                // 过滤课程
                if (num === 1) {
                    this.filterTypeList = this.campusSet
                } else if (num === 2) {
                    this.filterTypeList = this.gradeSet
                } else {
                    this.filterTypeList = this.classTimeSet
                }

                if (!numType) {
                    this.getClassList()
                }
            },
            // 根据已选的纬度显示课程列表
            getClassList() {
                let contentList = []
                this.tempPackageClassList = [] // 这是选择纬度后要重新赋值，需置空
                this.packageClassList.forEach( (packageItem) => {
                    if (this.packageCodeList.indexOf(packageItem.packageCode) > -1) {
                        let templateList = {
                            packageCode: packageItem.packageCode,
                            packageName: packageItem.packageName,
                            isSelectAll: packageItem.isSelectAll,
                            isSoldOut:  packageItem.isSoldOut || '',
                            classList: []
                        }
                        packageItem.classList.forEach((classItem) => {
                            if (this.classCodeList.indexOf(classItem.classCode) > -1) {
                                templateList.classList.push(classItem)
                            }
                        })

                        if (templateList.classList && templateList.classList.length >= 1) {
                            contentList.push(templateList)
                        }
                    }
                })
                this.tempPackageClassList = contentList
                this.total = contentList.length
                if (this.tempPackageClassList && this.tempPackageClassList.length === 1 && this.tempPackageClassList[0].classList.length <= 2) {
                    this.isShowPullUpFooter = false
                } else {
                    // 只有不存在详情图的情况下才可以设置为true
                    if (!this.activityInfo.detailUrl) {
                        this.isShowPullUpFooter = true
                    }
                }

                // 如果有图片则不显示加载更多，
                this.packageList = this.tempPackageClassList.slice(0, 5)
                if (!this.isShowPullUpFooter && this.packageList.length > 3) {
                    this.packageList = this.tempPackageClassList.slice(0,3)
                }
                this.getStartPullUpState()
                // console.log('最后筛选内容', contentList)
            },
            // 根据已选的纬度加载更多课程列表
            getMoreClassList () {
                let packageListIndex = this.packageList.length
                let moreClassList = this.tempPackageClassList.slice(packageListIndex, packageListIndex+5)
                this.packageList = this.packageList.concat(moreClassList)
            },
            // 获取套餐列表
            getMarketClassList() {
                let data = {
                    activityId: this.activityId
                }
                getNewMarketClassList(data).then((res) => {
                    let packageData = res.data
                    // 缓存信息
                    this.dimensionList = packageData.marketConfig
                    // packageData.packageClassList = JSON.parse(packageData.packageClassList)
                    if (packageData.packageClassList) {
                        packageData.packageClassList.forEach( (packageItem) => {
                            packageItem.isSelectAll = false
                            let haveSelectCourse = []  // 已经选择的课程
                            let packageClassList = [] // 套餐下可买课程
                            packageItem.classList.forEach((classItem) => {
                                // 购物车有数量时要自动匹配
                                let index = this.cartList && this.cartList.indexOf(classItem.classCode)
                                if (this.cartList && index > -1) {
                                    // 用于套餐按钮的变化
                                    classItem.isSelect = true
                                    // this.selectCourse(packageItem, classItem)
                                } else {
                                    classItem.isSelect = false
                                }

                                // 套餐下可买课程
                                if (classItem.registrationState !== 6) {
                                    let index = packageClassList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        packageClassList.push(classItem.classCode)
                                    }
                                }

                                // 已选择课程加入
                                if (classItem.isSelect) {
                                    let index = haveSelectCourse.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        haveSelectCourse.push(classItem.classCode)
                                    }
                                }
                            })

                            if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                                packageItem.isSelectAll = true
                            }

                            if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                                packageItem.isSoldOut = true
                            }

                        })
                        this.packageClassList = packageData.packageClassList
                        this.tempPackageClassList = packageData.packageClassList    // 首次加载需要给临时的存储一个值
                        this.total = packageData.packageClassList.length
                        this.packageList = packageData.packageClassList.slice(0, 5)
                        if (this.tempPackageClassList && this.tempPackageClassList.length === 1 && this.tempPackageClassList[0].classList.length <= 2) {
                            // 存在图片及套餐列表为1且课程列表为小于等于2时，怎不显示加载更多按钮
                            this.isShowPullUpFooter = false
                        }
                        if (!this.isShowPullUpFooter && this.packageList.length > 3) {
                            this.packageList = this.packageList.slice(0,3)
                        }
                    }

                    // 判断当前是否有参数
                    if (!this.schoolName && !this.gradeName && !this.timeName) {
                        this.getStartPullUpState()
                    } else {
                        this.getDimensionList()
                    }
                    Indicator.close()
                })
            },
            // 获取上拉加载的pullUpState状态
            getStartPullUpState () {
                if (this.packageList.length) {
                    if (this.total <= this.pageSize) {
                        // 修改子组件的pullUpState状态
                        this.pullUpState = 3
                    } else {
                        this.pullUpState = 1
                    }
                } else {
                    this.pullUpState = 0
                }
            },
            // 上拉加载
            onInfiniteLoad (done) {
                // 当有课程图片时，不支持加载更多
                if (!this.isShowPullUpFooter) {
                    return
                }
                if (this.pullUpState === 1) {
                    this.getPullUpMoreData()
                }
                done()
            },
            // 上拉一次加载更多的数据
            getPullUpMoreData () {
                // 调用课程列表
                // console.log('加载到底部', this.total, this.packageList.length)
                if (this.total === this.packageList.length) {
                    this.pullUpState = 3
                } else {
                    this.pullUpState = 1
                    this.getMoreClassList()
                }
            },
            // 全部套餐
            selectAll (packageInfo) {
                if (packageInfo.isSoldOut) {
                    return
                }
                this.packageList.forEach((packageItem) => {
                    if (packageItem.packageCode === packageInfo.packageCode) {
                        if (packageItem.isSelectAll) {
                            packageItem.classList.forEach((classItem) => {
                                classItem.isSelect = false
                                let index = this.cartList.indexOf(classItem.classCode)
                                if (index > -1) {
                                    this.cartList.splice(index, 1)
                                }
                            })
                        } else {
                            packageItem.classList.forEach((classItem) => {
                                if (classItem.registrationState !== 6) {
                                    classItem.isSelect = true
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        this.cartList.push(classItem.classCode)
                                    }
                                }
                            })
                        }
                        packageItem.isSelectAll = !packageItem.isSelectAll
                    }
                })
                sessionStorage.setItem('cartList',JSON.stringify(this.cartList))
                // 验证相同班号
                if (!packageInfo.isSelectAll) {
                    this.verifyClassCode()
                }
            },
            // 单个课程
            selectCourse (packageInfo, course) {
                let haveSelectCourse = []  // 已经选择的课程
                let packageClassList = [] // 套餐下可买课程
                if(course.registrationState === 6) {
                    return
                }
                this.packageList.forEach((packageItem) => {
                    if (packageItem.packageCode === packageInfo.packageCode) {
                        packageItem.classList.forEach((classItem) => {
                            if (classItem.classCode === course.classCode) {
                                classItem.isSelect = !classItem.isSelect
                                if (classItem.isSelect) {
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index === -1) {
                                        this.cartList.push(classItem.classCode)
                                        // 用于套餐按钮的变化
                                        haveSelectCourse.push(classItem.classCode)
                                    }
                                } else {
                                    let index = this.cartList.indexOf(classItem.classCode)
                                    if (index > -1) {
                                        this.cartList.splice(index, 1)
                                        // 用于套餐按钮的变化
                                        packageItem.isSelectAll = false
                                    }
                                }
                            }

                            // 套餐下可买课程
                            if (classItem.registrationState !== 6) {
                                let index = packageClassList.indexOf(classItem.classCode)
                                if (index === -1) {
                                    packageClassList.push(classItem.classCode)
                                }
                            }

                            // 已选择课程加入
                            if (classItem.isSelect) {
                                let index = haveSelectCourse.indexOf(classItem.classCode)
                                if (index === -1) {
                                    haveSelectCourse.push(classItem.classCode)
                                }
                            }
                        })
                        // 循环结束判断是否全选
                        if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                            packageItem.isSelectAll = true
                        }

                        if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                            packageItem.isSoldOut = true
                        }
                    }
                })
                sessionStorage.setItem('cartList',JSON.stringify(this.cartList))

                // 验证相同班号
                if (!course.isSelect) {
                    this.verifyClassCode()
                }
            },
            // 验证相同班号
            verifyClassCode () {
                if (this.packageList) {
                    this.packageList.forEach( (packageItem) => {
                        packageItem.isSelectAll = false
                        let haveSelectCourse = []  // 已经选择的课程
                        let packageClassList = [] // 套餐下可买课程
                        packageItem.classList.forEach((classItem) => {
                            // 购物车有数量时要自动匹配
                            let index = this.cartList && this.cartList.indexOf(classItem.classCode)
                            if (this.cartList && index > -1) {
                                // 用于套餐按钮的变化
                                classItem.isSelect = true
                            } else {
                                classItem.isSelect = false
                            }

                            // 套餐下可买课程
                            if (classItem.registrationState !== 6) {
                                let index = packageClassList.indexOf(classItem.classCode)
                                if (index === -1) {
                                    packageClassList.push(classItem.classCode)
                                }
                            }

                            // 已选择课程加入
                            if (classItem.isSelect) {
                                let index = haveSelectCourse.indexOf(classItem.classCode)
                                if (index === -1) {
                                    haveSelectCourse.push(classItem.classCode)
                                }
                            }
                        })

                        if (haveSelectCourse.length && haveSelectCourse.length === packageClassList.length) {
                            packageItem.isSelectAll = true
                        }

                        if (haveSelectCourse.length === 0 && packageClassList.length === 0) {
                            packageItem.isSoldOut = true
                        }
                    })
                }
            },
            // 查看所有课程
            checkAllCourse(){
                let params = this.getParams()
                let url = `/package/list?${params}`
                this.$router.push(url)
            },
            // 教学方式
            teachingMethod(methodCode) {
                return teachingMethodUtil(methodCode)
            },
            // 课时，课次
            getClassLessonTimes(lessonTimes, realMinutes) {
                return getClassLessonTimesUtil(lessonTimes, realMinutes)
            },
            // 住宿班
            getClassStay(modeCodes) {
                return getClassStayUtil(modeCodes)
            },
            // 名额紧张
            isFew(currentNum, maxNum, bmState) {
                return isFewUtil(currentNum, maxNum, bmState)
            },
            // 时间格式化
            formatDate(source, format) {
                return formatDateUtil(source, format)
            },
            // 记录渠道
            recordChannel(num) {
                let data = {
                    channelId: this.channelId,
                    u2at: this.U2AT,
                    wxNickname: this.wxNickName || '',
                    agn: this.agn || ''
                }
                recordChannel(data).then((res) => {
                    let reaData = res

                    if (reaData.code == 1 && reaData.data && reaData.data.userid) {
                        sessionStorage.setItem('userId', reaData.data.userid)
                        gio('setUserId', reaData.data.userid)
                    }
                })
            },
            // 登陆授权验证
            checkWxLogin(num) {
                checkWxLogin().then((res) => {
                    let reaData = res

                    let url = this.getHttpUrl()

                    // 微信授权
                    if (reaData.code == 4002 && this.isWeChat) {
                        let wxLogin = configData.wxlogin
                        window.parent.location.href = wxLogin + '&returnUrl=' + encodeURIComponent(url)
                    }

                    if (reaData.code == 200 && reaData.data && reaData.data.wxNickName) {
                        this.wxNickName = reaData.data.wxNickName
                    }

                    // 测试数据 记录渠道
                    if (!num) {
                        this.U2AT = Cookies.get('U2AT')
                        let userId = sessionStorage.getItem('userId')
                        if (this.U2AT && !userId) {
                            this.recordChannel()
                        }
                    }

                    // 登录过期
                    if (num === 1) {
                        if (reaData.code == 4000) {
                            let urlLogin = configData.h5Login
                            window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                        } else {
                            let orderUrl = this.getOrderUrl()
                            window.parent.location.href = orderUrl
                        }
                    }
                })
            },
            payMoney() {
                if (!this.isBeginActivity) {
                    Toast({
                        message: '当前活动还未开始哦~',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }
                if (this.cartList.length === 0) {
                    Toast({
                        message: '请选择需要报名的课程',
                        duration: 2000,
                        className: 'noticeError'
                    })
                    return
                }

                // 在app中去登陆
                if (xdfJs.xdfhybird.inApp) {
                    this.getAppToken()
                    return
                }

                if (this.U2AT) {
                    if (this.cartList && this.cartList.length === 0) {
                        return
                    }
                    // 已登陆
                    this.checkWxLogin(1)
                } else {
                    // 未登录
                    let urlLogin = configData.h5Login
                    let url = this.getOrderUrl()
                    window.parent.location.href = urlLogin + '&redirect_uri=' + encodeURIComponent(url)
                }
            },
            // 获取app的token
            getAppToken() {
                xdfJs.xdfhybird.getUser( (data) => {
                    // 判断用户是否登陆
                    if (
                        data &&
                        data.user &&
                        !!data.user.userId &&
                        data.user.userId.length > 0
                    ) {
                        let token = data["user"]["accessToken"]
                        this.U2AT = token
                        Cookies.set('U2AT', token, { expires: 30, domain: 'xdf.cn' })
                        this.recordChannel()
                        // 跳转到支付
                        let url = this.getOrderUrl()
                        if (token) {
                            xdfJs.xdfhybird.openURL("xdfapp://student/web", {"url": url})
                        }
                    } else {
                        xdfJs.xdfhybird.openURL("xdfapp://student/login", {})
                    }
                })
            },
            // 微信分享
            getWxSdk() {
                let shareObj = {
                    urlLogo: this.activityInfo.shareUrl || '',// 分享图标
                    desc: this.activityInfo.shareDesc || ''
                }

                shareObj.title = this.activityInfo.shareTitle || this.activityInfo.title
                let params = this.getParams()
                shareObj.link = configData.originUrl + 'package?' + params
                console.log('分享链接', shareObj.link)
                wxSdk.getWxSdk(shareObj)
            },
            // 获取跳转参数
            getParams() {
                let params = `activityId=${this.activityId}&channelId=${this.channelId}&schoolName=${this.schoolName}&gradeName=${this.gradeName}&timeName=${this.timeName}` +
                    `&selectSchoolId=${this.selectSchoolId}&selectGradeId=${this.selectGradeId}&selectTimeId=${this.selectTimeId}&selectNavString=${this.selectNavString}&filterNum=${this.filterNum}&agn=${this.agn}`
                return params
            },
            // 获取分享链接
            getHttpUrl() {
                let httpUrl = configData.originUrl + 'package?'
                let params = this.getParams()
                let url =  httpUrl + params
                return url
            },
            // ios内打电话
            callPhone() {
                if (!this.isIosApp) {
                    return
                }
                xdfJs.xdfhybird.loadPlugin("XDFHybirdCallPhonePlugin")
                xdfJs.xdfhybird.callPlugin("XDFHybirdCallPhonePlugin", "callPhone", {
                    number: Number(this.phone)
                })
            },
            // 获取新的渠道参数agn
            getGan() {
                // 专题详情
                let data = {
                    activityId: this.activityId,
                    agn: this.agn
                }
                getGan(data).then((res) => {
                    let resData = res
                    if (resData.code == 1) {
                        this.agentName = resData.data.agentName
                    }
                })
            },
            // 提取订单URl
            getOrderUrl() {
                let classCodeList = this.cartList.join(",")
                let marketingSource = this.activityId + '_' + this.channelId
                if (this.agn) {
                    marketingSource = this.activityId + '_' + this.agn
                }
                let marketingSourceExt = this.activityInfo.uniActivityId
                let params = `appId=${configData.appId}&systemSource=${configData.systemSource}&schoolId=${this.schoolId}` +
                    `&classCodes=${classCodeList}&studentCode=&preOrderCode=&marketingSource=${marketingSource}&agentName=${this.agentName}&marketingSourceExt=${marketingSourceExt}`
                let orderUrl = `${configData.h5Bm}/page-h5bm/order?${params}`
                return orderUrl
            }
        }
    }
</script>
<style lang="less" scoped>
    .course_content {
        padding-bottom:100px;
        .course_bg {
            width: 100%;
        }
        .title_radius {
            position: relative;
            width:100%;
            height:20px;
            background: #fff;
            border-radius:20px 20px 0px 0px;
            margin-top: -20px;
            margin-bottom: 12px;
        }
        .banner_height {
            width: 100%;
            height: 32px;
        }
        /*标题栏内容*/
        .title_content {
            margin-bottom: 80px;
            .school_title_content {
                width:686px;
                height:96px;
                background:rgba(255,255,255,1);
                box-shadow:0px 4px 20px 0px rgba(206,223,241,0.3);
                border-radius:20px;
                margin: 0 auto 32px;
                padding-left: 16px;
                padding-right: 40px;
                position: relative;
                .school_icon {
                    width: 68px;
                    height: 68px;
                }
                .school_title {
                    width:514px;
                    font-size:30px;
                    color:rgba(51,51,51,1);
                    line-height:40px;
                    font-weight: 400;
                }
                .down_arrow_icon {
                    width: 18px;
                    height: 12px;
                    margin-left: auto;
                }
            }
            .school_title_content:after {
                content: ".";
                color: transparent;
                width: 200%;
                height: 200%;
                border: 1px solid rgba(237,240,247,0.7);
                border-radius:20px;
                transform-origin: 0 0;
                transform: scale(.5,.5);
                position: absolute;
                left: 0;
                top: 0;
            }
        }
        /*查看全部课程*/
        .check_all_course {
            justify-content: center;
            margin-bottom: 60px;
            margin-top: 56px;
            .all_course_title {
                font-size:24px;
                color:rgba(252,148,53,1);
                line-height:34px;
                margin-right: 20px;
            }
            .course_left_arrow {
                width: 10px;
                height: 18px;
            }
        }
        /*课程图片内容*/
        .course_img {
            margin-top: 60px;
            width: 100%;
            img {
                display: block;
                width: 100%;
            }
        }
        /*学校列表*/
        .school_list_bg {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            z-index: 1001;
            background:rgba(0,0,0,0.7);
            .school_content {
                position: absolute;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                width:750px;
                background: #fff;
                border-radius:20px 20px 0px 0px;
                overflow: auto;
                padding: 42px 32px 0;
                .school_title_content {
                    justify-content: space-between;
                    margin-bottom: 30px;
                    .school_title {
                        font-size:40px;
                        font-weight:bold;
                        color:rgba(30,30,30,1);
                        line-height:56px;
                    }
                    .close_icon {
                        width: 32px;
                        height: 32px;
                        margin-top: -16px;
                    }
                }
                .school_list {
                    max-height: 800px;
                    min-height: 660px;
                    overflow-y: scroll;
                    .school_list_info {
                        .school_name {
                            font-size:30px;
                            color:rgba(30,30,30,1);
                            line-height:42px;

                        }
                        .school_name_color {
                            color: #1FB895;
                        }
                        .dot_line {
                            width:686px;
                            height: .5px;
                            background:rgba(227,227,227,1);
                            border-radius:10px;
                            transform: scale(1,.5);
                            margin: 28px auto 30px;
                        }
                    }
                }
            }
        }
    }
    .course_content_compatible {
        overflow:auto;
        -webkit-overflow-scrolling:touch;
        height:calc(100vh);
    }
    .course_content_bottom {
        padding-bottom:170px;
    }
    .course_content_bottom_iphoneX {
        padding-bottom:168px;
    }
</style>
